module.exports = __webpack_public_path__ + "img/candles.9ce2c011.jpg";